import { useState, useCallback } from "react";

const useConfirmationModal = ({ onConfirm, onCancel } = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [config, setConfig] = useState({
    label: "Confirm",
    confirmationType: "default",
    dynamicData: null,
  });

  const showModal = ({ label, confirmationType, subCat, dataObject }) => {
    const dynamicData = subCat?.id;
    setConfig({
      label,
      confirmationType,
     dynamicData: dynamicData ||  dataObject, 
    });
    setIsVisible(true);
  };


  const hideModal = useCallback(() => {
    setIsVisible(false);
    if (onCancel) onCancel();
  }, [onCancel]);

  const confirmAction = useCallback(() => {
    if (onConfirm) onConfirm(config.dynamicData);
    setIsVisible(false);
  }, [onConfirm, config.dynamicData]);

  return { isVisible, config, showModal, hideModal, confirmAction };
};

export default useConfirmationModal;
